import React, { useEffect, useRef } from "react";
import { Chessground } from "chessground";
import "chessground/assets/chessground.base.css";
import "chessground/assets/chessground.brown.css";
import "chessground/assets/chessground.cburnett.css";
import Board from "./Board";

// A read-only-ish explorer board: the only legal moves are the ones passed in
// `dests` (built from the games), and each completed move is reported via
// `onMove(from, to)`.
const ExplorerBoard = ({ fen, dests, turnColor, orientation, onMove }) => {
  const el = useRef(null);
  const cg = useRef(null);
  const onMoveRef = useRef(onMove);
  onMoveRef.current = onMove;

  useEffect(() => {
    cg.current = Chessground(el.current, {
      fen,
      orientation,
      turnColor,
      coordinates: false,
      movable: {
        free: false,
        color: turnColor,
        dests,
        showDests: true,
        events: { after: (orig, dest) => onMoveRef.current(orig, dest) },
      },
    });
    return () => {
      if (cg.current) cg.current.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!cg.current) return;
    cg.current.set({
      fen,
      orientation,
      turnColor,
      movable: {
        free: false,
        color: turnColor,
        dests,
        showDests: true,
        events: { after: (orig, dest) => onMoveRef.current(orig, dest) },
      },
    });
  }, [fen, dests, turnColor, orientation]);

  return <Board ref={el} />;
};

export default ExplorerBoard;
